import React, { useState } from 'react'
import { API_HOST, authenticatedFetchData } from '../../../../lib'
import { logError } from '@tomra/datadog-browser-logging'
import { Dialog } from '../../../common/Dialog'
import { DateWithUTCTooltip } from '../../../common'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  userId: string
  onClose: (status: RequestStatusType) => void
  scheduledDeleteAt: string | null
}

export const CancelScheduledDeleteDialog = ({ userId, onClose, scheduledDeleteAt }: Props) => {
  const [status, setStatus] = useState<RequestStatusType>('idle')
  const [responseMessage, setResponseMessage] = useState<string>('')

  const cancelScheduledDelete = async () => {
    try {
      setStatus('pending')
      await authenticatedFetchData(`${API_HOST}/mytomra/v1.0/hotlinetool/cancel-scheduled-delete?userId=${userId}`, {
        method: 'POST'
      }).run()
      setStatus('success')
    } catch (error: any) {
      setStatus('failure')
      setResponseMessage(error.message)
      logError(new Error('Failed to remove scheduled user delete'), error)
    }
  }

  return (
    <>
      <Dialog ariaLabel={'Cancel scheduled user delete'} onClose={() => onClose(status)}>
        <div className="rounded-2xl bg-white shadow-md dark:bg-gray-900 p-9 flex flex-col gap-y-6 max-w-35">
          <h1 className="text-xl">Cancel scheduled delete</h1>

          {status === 'idle' ? (
            <p>
              User is scheduled for deletion at <DateWithUTCTooltip date={new Date(scheduledDeleteAt as string)} />
            </p>
          ) : status === 'success' ? (
            <p>Great! Scheduled delete is removed.</p>
          ) : status === 'failure' ? (
            <>
              <p className="rounded-lg border-l-[3px] border-rose-500 bg-white p-4 text-left shadow-md dark:bg-gray-900">
                Whoopsie! Something went wrong. {responseMessage}
              </p>
            </>
          ) : null}

          {status !== 'success' && (
            <Button variant="primary" className="self-end" onClick={cancelScheduledDelete}>
              {status === 'pending' ? <div className="loadingSpinner" /> : 'Remove scheduled delete'}
            </Button>
          )}
        </div>
      </Dialog>
    </>
  )
}
